module.exports = __webpack_public_path__ + "static/media/icon-drone.82361ffb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-drone.svg
// module id = 173
// module chunks = 0